import { Tag } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import { config } from '../../constant';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { guageLineMockJson } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const GuageLine = (props) => {

  const [option, setOption] = useState(getOption(props));
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);

  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);

  // useEffect(() => {
  //   return () => {
  //     abortController.current.abort();
  //     clearInterval(timeTicket);
  //   };
  // });
  function getOption() {
    let theme = props.selectedThemeing;
    let option = {
      tooltip: {
        trigger: 'axis'
        // formatter: '{b} <br/>  {c}'
      },
      label: {
        color: theme === 'lightTheme' ? 'black' : 'white',
        fontWeight: 'bold',
        fontSize: 14
      },
      textStyle: {
        color: theme === 'lightTheme' ? 'black' : 'white',
        fontWeight: 'bold',
        fontSize: 18
      },
      legend: {
        left: 'center',
        textStyle: {
          color: theme === 'lightTheme' ? 'black' : 'white'
        }
      },
      // tooltip: {
      //   trigger: "axis",
      //   //showContent: false
      // },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            name: props.graphprops.title,
            backgroundColor: 'black',
            iconStyle: {
              // color: "none",
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },

      grid: [
        {
          top: '45%',
          width: '90%',
          bottom: '45%',
          left: 50,
          height: '50%',
          containLabel: true
        },
        {
          top: 0,
          width: '50%',
          bottom: '100%',
          left: 0,
          height: '50%',
          containLabel: false
        }
      ],
      xAxis: {
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white'
        },
        type: 'category'
      },
      yAxis: {
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white'
        },
        gridIndex: 0
      }
    };
    return option;
  }
  const getData = async () => {
    let theme = props.selectedThemeing;
    requestCheck.current = false;
    // errorInAPI = false;
    // noDataInDB = false;
    setErrorInAPI(false);
    setNoDataInDB(false);
    let json = [];
    let { graphprops } = props;

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = guageLineMockJson;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      var guage = json && json.query;
      var line = json && json.query1;
      if (line && Array.isArray(line)) {
        let dates = [];
        let values = [];
        let name = '';
        let tagnames = [];
        let series = [];
        let legendsdata = [];
        // let finalArray = [];
        line.map((val) => {
          if (val.Name !== name) {
            if (tagnames.indexOf(val.Name) === -1) {
              tagnames.push(val.Name);
              name = val.Name;
              legendsdata.push({
                name: val.Description,

                icon: 'roundRect',

                textStyle: {
                  color: theme === 'lightTheme' ? 'black' : 'white',
                  fontSize: 16,
                  fontWeight: 'bold'
                }
              });
            }
          }
          return {};
        });

        let yAxis = {
          axisLine: {
            lineStyle: {
              color: theme === 'lightTheme' ? 'black' : 'white'
            }
          },
          axisTick: {
            lineStyle: {
              color: theme === 'lightTheme' ? 'black' : 'white'
            }
          },
          axisLabel: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          },
          gridIndex: 0
        };

        tagnames.map((tagval, tagindex) => {
          values = [];
          line.map((jsonval) => {
            if (tagnames[0] === jsonval.Name && tagindex === 0) {
              dates.push(
                moment
                  .utc(jsonval.DateTime)
                  .tz(props.currentTimeZone)
                  .format('DD/MM/YYYY HH:mm:ss')
              );
            }
            if (tagval === jsonval.Name) {
              values.push(jsonval.Value);
            }
            return {};
          });

          series.push({
            name: legendsdata[tagindex]['name'],
            data: values,
            type: 'line',
            axisLabel: { fontSize: 15 },
            //   areaStyle: {},
            smooth: true
          });
          return {};
        });

        tagnames.map((tagval) => {
          values = [];
          Object.keys(guage).map((jsonval) => {
            if (tagval === jsonval.Name) {
              values.push(jsonval.Value);
            }
            return {};
          });
          return {};
        });

        guage = Object.keys(guage).map((jsonData) => {
          return {
            name:
              props.graphprops && props.graphprops.uom ? props.graphprops.uom : '',
            title: {
              offsetCenter: [0, '20%'],
              fontSize: 20,
              fontStyle: 'italic',
              color:
                props.graphprops && props.graphprops.titleColor
                  ? props.graphprops.titleColor
                  : ''
            },
            // name: jsonData,
            value: guage[jsonData].Value
          };
        });
        series.push({
          // name: legendsdata[tagindex]["name"],
          splitNumber: 8,
          min:
            graphprops && graphprops.range !== undefined && graphprops.range !== null
              ? graphprops.range[0]
              : 0,
          max:
            graphprops && graphprops.range !== undefined && graphprops.range !== null
              ? graphprops.range[1]
              : 1000,

          type: 'gauge',
          radius: '40%',
          center: ['50%', '25%'],
          axisLine: {
            lineStyle: {
              width: 30,
              color: [
                [0.3, '#67e0e3'],
                [0.7, '#37a2da'],
                [1, '#fd666d']
              ]
            }
          },
          pointer: {
            itemStyle: {
              color: 'auto'
            }
          },
          axisTick: {
            distance: -30,
            length: 8,
            lineStyle: {
              color: '#fff',
              width: 2
            }
          },
          splitLine: {
            distance: -30,
            length: 30,
            lineStyle: {
              color: '#fff',
              width: 4
            }
          },
          axisLabel: {
            color: 'auto',
            distance: 40,
            fontSize: 10
          },
          detail: {
            valueAnimation: true,
            formatter: '{value}',
            color: 'auto',
            fontSize: 20
          },
          data: guage
        });

        const option = cloneDeep(getOption());
        series = await trendLabelTranslation(series, props.translationCache);
        option.xAxis.data = [...dates];
        option.yAxis = { ...yAxis };
        option.series = [...series];
        option.legend = [...legendsdata];
        setOption(option);
        setRefreshDateTime(moment());
      }
      setErrorInAPI(errorInAPI);
      setNoDataInDB(noDataInDB);
    }
  };


  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          option={option}
          notMerge={true}
          lazyUpdate={true}
          //onEvents={onEvents}
          style={{ height: '90%', width: '100%' }}
          className="react_for_echarts"
        />
      )}
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(GuageLine);
